import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import CountryOfOrigin from "@/components/molecules/RegisterCompanySteps/CountryOfOrigin";
import CompanyDetails from "@/components/molecules/RegisterCompanySteps/CompanyDetails";
import ContactInformation from "@/components/molecules/RegisterCompanySteps/ContactInformation";
import CompanyAddress from "@/components/molecules/RegisterCompanySteps/CompanyAddress";

interface CompanyInformationPanelProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
  errors?: FieldErrors<RegisterCompanyFormInput>;
}

const CompanyInformationPanel: React.FC<CompanyInformationPanelProps> = ({ control, saveDraft }) => {
  return (
    <React.Fragment>
      <CountryOfOrigin control={control} saveDraft={saveDraft} />
      <CompanyDetails control={control} saveDraft={saveDraft} />
      <ContactInformation control={control} saveDraft={saveDraft} />
      <CompanyAddress control={control} saveDraft={saveDraft} />
    </React.Fragment>
  );
};

export default CompanyInformationPanel;
